import React from "react"
import Skeleton from "react-loading-skeleton"

function MerchandiseCardSkeleton() {
  return (
    <div className="uk-card" style={{ width: 280 }}>
      <div className="uk-height-medium uk-card-media-top uk-width-1-1">
        <Skeleton className="uk-height-1-1 uk-width-1-1" />
      </div>
      <div className="merchandise-desc uk-flex uk-flex-column">
        <Skeleton width={140} height={14} />
        <Skeleton width={80} height={12} className="uk-margin-small-bottom" />
        <Skeleton width={60} height={10} className="uk-align-right" />
      </div>
    </div>
  )
}

export default MerchandiseCardSkeleton
